module.exports = __webpack_public_path__ + "static/media/Raggruppa_75.23957d57.svg";